import { render, staticRenderFns } from "./stock-mapping.vue?vue&type=template&id=527b0188&scoped=true"
import script from "./stock-mapping.vue?vue&type=script&lang=ts"
export * from "./stock-mapping.vue?vue&type=script&lang=ts"
import style0 from "./stock-mapping.vue?vue&type=style&index=0&id=527b0188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b0188",
  null
  
)

export default component.exports